import { SelectionOptionsPopUpButtonModule } from './../../../widgets/selection-options-pop-up-button/selection-options-pop-up-button.module';
import { SettingsPopUpButtonModule } from './../../../widgets/settings-pop-up-button/settings-pop-up-button.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StockOverviewComponent } from './stock-overview.component';
import { DxDataGridModule, DxChartModule, DxTextAreaModule, DxRangeSelectorModule, DxPopupModule, DxSwitchModule } from 'devextreme-angular';
import { DevEpressCommonModule } from 'src/app/dev-epress-common.module';
import { StockOverviewRoutingModule } from './stock-overview-routing.module';
import { BookmarkModule } from 'src/app/widgets/bookmark/bookmark.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { WebExportModule } from 'src/app/widgets/web-export/web.export.module';
import { BookmarkNewComponent } from 'src/app/widgets/bookmark-new/bookmark-new.component';
import { FiltersGroupModule } from 'src/app/widgets/filters/filters-group/filters-group.module';
import { HelpButtonComponent } from 'src/app/widgets/help-button/help-button.component';




@NgModule({
  declarations: [StockOverviewComponent],
  imports: [
    CommonModule,
    DxChartModule,
    DxTextAreaModule,
    DxDataGridModule, DxRangeSelectorModule,
    DevEpressCommonModule, DxSwitchModule,FiltersGroupModule,HelpButtonComponent,BookmarkNewComponent,
    StockOverviewRoutingModule, BookmarkModule, DxPopupModule, FormsModule, ReactiveFormsModule,

    SettingsPopUpButtonModule,
    SelectionOptionsPopUpButtonModule, WebExportModule
  ]
})
export class StockOverviewModule { }  
